export default __webpack_public_path__ + "static/media/download.94d39431.svg";